import { render, staticRenderFns } from "./TemplateSettings.vue?vue&type=template&id=7cf3a5d4&scoped=true"
import script from "./TemplateSettings.vue?vue&type=script&lang=js"
export * from "./TemplateSettings.vue?vue&type=script&lang=js"
import style0 from "./TemplateSettings.vue?vue&type=style&index=0&id=7cf3a5d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf3a5d4",
  null
  
)

export default component.exports